/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Target category the agent scanned under: harness, assistant, or local_model. The server catalog's category wins for targets it knows; this is what gets stored for the rest.
 */
export const AIScanMatchCategory = {
  Harness: "harness",
  Assistant: "assistant",
  LocalModel: "local_model",
} as const;
/**
 * Target category the agent scanned under: harness, assistant, or local_model. The server catalog's category wins for targets it knows; this is what gets stored for the rest.
 */
export type AIScanMatchCategory = ClosedEnum<typeof AIScanMatchCategory>;

/**
 * What the scan observed: installed or running.
 */
export const Signal = {
  Installed: "installed",
  Running: "running",
} as const;
/**
 * What the scan observed: installed or running.
 */
export type Signal = ClosedEnum<typeof Signal>;

/**
 * One AI detection target a device-agent scan matched.
 */
export type AIScanMatch = {
  /**
   * Target category the agent scanned under: harness, assistant, or local_model. The server catalog's category wins for targets it knows; this is what gets stored for the rest.
   */
  category: AIScanMatchCategory;
  /**
   * What the scan observed: installed or running.
   */
  signal: Signal;
  /**
   * Identifier of the matched target from the agent's compiled-in list (e.g. claude-code, ollama). Stored as reported: an agent binary can ship a newer target list than the server catalog knows.
   */
  targetId: string;
  /**
   * Installed version, when the scan could read one statically (e.g. from the app bundle's Info.plist).
   */
  version?: string | undefined;
};

/** @internal */
export const AIScanMatchCategory$outboundSchema: z.ZodMiniEnum<
  typeof AIScanMatchCategory
> = z.enum(AIScanMatchCategory);

/** @internal */
export const Signal$outboundSchema: z.ZodMiniEnum<typeof Signal> = z.enum(
  Signal,
);

/** @internal */
export type AIScanMatch$Outbound = {
  category: string;
  signal: string;
  target_id: string;
  version?: string | undefined;
};

/** @internal */
export const AIScanMatch$outboundSchema: z.ZodMiniType<
  AIScanMatch$Outbound,
  AIScanMatch
> = z.pipe(
  z.object({
    category: AIScanMatchCategory$outboundSchema,
    signal: Signal$outboundSchema,
    targetId: z.string(),
    version: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      targetId: "target_id",
    });
  }),
);

export function aiScanMatchToJSON(aiScanMatch: AIScanMatch): string {
  return JSON.stringify(AIScanMatch$outboundSchema.parse(aiScanMatch));
}
